import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'components';
import { P } from 'components/Typography/Typography';
import { t } from 'i18next';
import { DisabledProfileSection } from '../../ProfileView.styled';

/** Zmiana e-mailu tymczasowo wyłączona – sekcja tylko do odczytu (wyszarzona, bez rozwinięcia). */
export const EmailAddressForm = () => {
  return (
    <DisabledProfileSection>
      <Flex p={2} alignItems="center">
        <FontAwesomeIcon icon={faEnvelope} />
        <P ml={2} variant="body" color="grey">
          {t('profile.changeEmailAddress')}
        </P>
      </Flex>
    </DisabledProfileSection>
  );
};
